import { useParams } from 'react-router';

import type { HorizonAppRouteGroupLoaderArgs } from '#/routing/classes/types/AppRouteGroupLoaderArgs';
import type { cmsFilesRouteGroup } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { ViewPdfFilePageLoadable } from './ViewPdfFilePageLoadable';

// oxlint-disable-next-line no-empty-pattern
export async function loader({}: HorizonAppRouteGroupLoaderArgs<
  typeof cmsFilesRouteGroup
>) {
  await ViewPdfFilePageLoadable.load();
  return {};
}

export default function ViewPdfFileHorizonRoute({
  // oxlint-disable-next-line no-empty-pattern
  loaderData: {},
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { '*': filename } = useParams();
  return <ViewPdfFilePageLoadable filename={filename!} />;
}
